import Button from 'raydiant-elements/core/Button';
import withStyles, {
  createStyles,
  WithStyles,
} from 'raydiant-elements/core/withStyles';
import withThemeSelector from 'raydiant-elements/core/withThemeSelector';
import { Theme } from 'raydiant-elements/theme';
import * as React from 'react';
import { colors, maxPageWidth } from '../constants';
import logger from '../logger';

interface JobPostsProps extends WithStyles<typeof styles> {}

const ApplyForThisJobButton = ({ applyUrl }: { applyUrl: string }) => (
  <Button
    color="progress"
    label="APPLY FOR THIS JOB"
    onClick={() => {
      window.open(applyUrl);
    }}
  />
);

interface JobPost {
  additional: string;
  additionalPlain: string;
  applyUrl: string;
  categories: {
    commitment: string;
    location: string;
    team: string;
  };
  createdAt: string;
  description: string;
  descriptionPlain: string;
  hostedUrl: string;
  id: string;
  lists: any[];
  text: string;
}

interface JobPostsState {
  items: JobPost[];
}

class JobPosts extends React.Component<JobPostsProps, JobPostsState> {
  state: JobPostsState = {
    items: [],
  };

  componentDidMount() {
    this.getJobPosts();
  }

  getJobPosts = async () => {
    try {
      const res = await fetch(
        'https://api.lever.co/v0/postings/raydiant?mode=json',
        {
          method: 'GET',
          headers: {
            Accept: 'application/json',
          },
        }
      );

      if (!res.ok) {
        throw new Error(`Invalid response '${res.statusText}'`);
      }

      const items: JobPost[] = await res.json();
      this.setState({ items });
    } catch (err) {
      logger.error(`Fetch job posts failed: ${err.message}`);
    }
  };

  render() {
    const { classes } = this.props;
    const { items } = this.state;
    return (
      <div className={classes.root}>
        {items.map(
          (
            { text, categories, applyUrl, description, descriptionPlain },
            i
          ) => (
            <div key={i} className={classes.jobPost}>
              <div className={classes.headerOuter}>
                <div className={classes.inner}>
                  <div style={{ width: '100%' }}>
                    <div className={classes.headerSection}>
                      <div className={classes.title}>{text}</div>
                      <div className={classes.ctaSection}>
                        <ApplyForThisJobButton applyUrl={applyUrl} />
                      </div>
                    </div>
                    <div className={classes.subheaderSection}>
                      <div className={classes.subheader}>
                        location: {categories.location}
                      </div>
                      <div className={classes.subheader}>
                        team: {categories.team}
                      </div>
                      <div className={classes.subheader}>
                        position: {categories.commitment}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className={classes.descriptionOuter}>
                <div className={classes.inner}>
                  <div
                    className={classes.jobDescription}
                    dangerouslySetInnerHTML={{ __html: description }}
                  />
                  <ApplyForThisJobButton applyUrl={applyUrl} />
                </div>
              </div>
            </div>
          )
        )}
        ;
      </div>
    );
  }
}

const styles = (theme: Theme) =>
  createStyles({
    root: {
      paddingTop: theme.spacing.unit * 10,
      paddingBottom: theme.spacing.unit * 10,
      background: theme.palette.background.default,
    },
    headerOuter: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',

      [theme.breakpoints.down('sm')]: {
        paddingBottom: theme.spacing.unit * 5,
      },
    },
    descriptionOuter: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      background: colors.grey,
      paddingTop: theme.spacing.unit * 5,
      paddingBottom: theme.spacing.unit * 10,
      color: theme.palette.text.heading,

      [theme.breakpoints.down('sm')]: {
        paddingBottom: theme.spacing.unit * 5,
      },
    },
    inner: {
      width: '100%',
      maxWidth: maxPageWidth,
      paddingLeft: theme.spacing.unit * 2,
      paddingRight: theme.spacing.unit * 2,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    headerSection: {
      display: 'flex',
      marginBottom: theme.spacing.unit * 2,
      flexDirection: 'column',
      [theme.breakpoints.up('sm')]: {
        alignItems: 'center',
        marginBottom: 0,
        flexDirection: 'row',
      },
    },
    subheaderSection: {
      marginBottom: theme.spacing.unit * 2,
    },
    title: {
      color: theme.palette.text.heading,
      fontSize: theme.fontSizes.xl,
      fontWeight: 500,
      [theme.breakpoints.down('sm')]: {
        marginBottom: theme.spacing.unit * 1,
      },
    },
    subheader: {
      textTransform: 'uppercase',
      color: colors.darkGrey,
      fontSize: theme.fontSizes.sm,
      fontWeight: 600,
      letterSpacing: 2,
    },
    ctaSection: {
      [theme.breakpoints.up('sm')]: {
        marginLeft: 'auto',
      },
    },
    jobDescription: {
      marginBottom: theme.spacing.unit * 5,
    },
    jobPost: {
      marginBottom: theme.spacing.unit * 25,
    },
  });

export default withThemeSelector(withStyles(styles)(JobPosts), 'light');
